import React, { useState, useEffect } from 'react';
import { IHomecareCategory } from 'src/types/GlobalInterfaces';
import ImageUpload from '../GlobalComponents/ImageUplaod';
import SimpleInput from '../SimpleInput';
import PrimaryBtn from '../GlobalComponents/primaryBtn';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';

interface IUpsertCategoryProps {
    isEdit?: IHomecareCategory | null;
    onSuccess: () => void;
};

const UpsertHomecareCategories: React.FC<IUpsertCategoryProps> = ({ isEdit = null, onSuccess = () => { } }) => {
    const [categoryName, setCategoryName] = useState<string>("");
    const [categoryImage, setCategoryImage] = useState<File | null | string>(null);
    const [categoryBanner, setCategoryBanner] = useState<File | null | string>(null);
    const [categoryDescription, setCategoryDescription] = useState<string>("");

    const [isLoader, setIsLoader] = useState<boolean>(false);

    const handleSubmit = async () => {
        if (!categoryName) {
            toast("Category name is mandatory!", { type: 'error' });
        } else if (!categoryImage) {
            toast("Category image is mandatory!", { type: 'error' });
        } else if (!categoryBanner) {
            toast("Category banner is mandatory!", { type: 'error' });
        } else if (!categoryDescription) {
            toast("Category description is mandatory!", { type: 'error' });
        } else {
            setIsLoader(true);
            const formData = new FormData();
            formData.append("categoryName", categoryName);
            formData.append("categoryImage", categoryImage);
            formData.append("categoryBanner", categoryBanner);
            formData.append("categoryDescription", categoryDescription);
            const path = isEdit && typeof isEdit !== 'boolean' ? `/homecare-category/${isEdit._id}` : "/homecare-category/create";
            const { res, err } = await httpRequest<{ data: IHomecareCategory; message: string; }>({ method: isEdit ? "put" : "post", path, params: formData, header: { "Content-Type": "multipart/form-data" } });
            if (res) {
                toast(res?.message || `Homecare Category ${isEdit ? "updated" : "added"} successfully`, { type: 'success' });
                onSuccess();
            } else {
                toast(err, { type: 'error' });
            }
            setIsLoader(false);
        }
    };

    useEffect(() => {
        if (isEdit) {
            let { categoryName = "", categoryImage = "", categoryBanner = "", categoryDescription = "" } = isEdit;
            setCategoryName(categoryName);
            setCategoryImage(categoryImage);
            setCategoryBanner(categoryBanner);
            setCategoryDescription(categoryDescription);
        }
    }, [isEdit]);

    return (
        <div className='admin-create-role-main'>
            <div className='admin-create-role'>
                <div className='create-operators-res '>
                    <h3 className='font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular'><span className='text-[#FF0000]'>* </span>
                        Category Banner</h3>
                    <ImageUpload
                        image={categoryBanner}
                        onImageChange={setCategoryBanner}
                        labelId='category-banner-input'
                        extraClasses='w-full'
                    />
                    <h3 className='font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular'><span className='text-[#FF0000]'>* </span>
                    Category Image</h3>
                    <ImageUpload
                        image={categoryImage}
                        onImageChange={setCategoryImage}
                        labelId='category-image-input'
                    />
                    <SimpleInput
                        value={categoryName}
                        onChange={setCategoryName}
                        isLabel={true}
                        labelText="Category Name"
                        isRequired={true}
                        id='category-name-input'
                        maxLength={100}
                    />
                    <SimpleInput
                        value={categoryDescription}
                        onChange={setCategoryDescription}
                        isLabel={true}
                        labelText="Category Description"
                        isRequired={true}
                        type='textArea'
                        id='category-description-input'
                        maxLength={500}
                        isLimit={500}
                    />
                </div>
            </div>
            <div className='flex justify-end my-6'>
                <PrimaryBtn
                    loader={isLoader}
                    ButtonText="Save"
                    btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
                    onPress={handleSubmit}
                    id='save-category-btn'
                />
            </div>
        </div>
    );
};

export default UpsertHomecareCategories;